import { useRef } from "react";
import { useServiceId, useMutationUI } from "../../../hooks";
import { useAnalytics } from "../../../analytics";
import { InstantRunWargameMutation } from "../../../graphql";
export var useExecuteRecommendedFault = function () {
    var temlateIdRef = useRef("");
    var sendTrackEvent = useAnalytics().sendTrackEvent;
    var serviceId = useServiceId();
    var _a = useMutationUI({
        mutation: InstantRunWargameMutation,
        successMessage: "Wargame will start in a few seconds",
        options: {
            onCompleted: function (data) {
                sendTrackEvent({
                    action: "executed",
                    actionSubject: "recommendedFault",
                    actionSubjectId: temlateIdRef.current,
                    source: "homeScreen",
                    attributes: data.instantRunWarGame
                });
            },
            onError: function (error) {
                sendTrackEvent({
                    action: "executionFailed",
                    actionSubject: "recommendedFault",
                    actionSubjectId: temlateIdRef.current,
                    source: "homeScreen",
                    attributes: {
                        message: error.message
                    }
                });
            }
        }
    }), isLoading = _a.isLoading, mutate = _a.mutate;
    var mutationFunction = function (_a) {
        var recommendedFaultId = _a.recommendedFaultId, environment = _a.environment;
        temlateIdRef.current = recommendedFaultId;
        mutate({
            variables: {
                service: serviceId,
                templateId: recommendedFaultId,
                input: { environment: environment }
            }
        });
    };
    return {
        isLoading: isLoading,
        mutate: mutationFunction
    };
};
